var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import AbyssalNexusImage from '../images/abyssal_nexus.png';
import AkkhaImage from '../images/akkha.png';
import BabaImage from '../images/baba.png';
import BareGroundImage from '../images/bare_ground.png';
import CatacombsOfKourendImage from '../images/catacombs_of_kourend.png';
import ChambersOfXericImage from '../images/chambers_of_xeric.png';
import GodWarsDungeonImage from '../images/god_wars_dungeon.png';
import GrassImage from '../images/grass.png';
import KephriImage from '../images/kephri.png';
import NightmareImage from '../images/nightmare.png';
import PrifddinasImage from '../images/prifddinas.png';
import RevenantCavesImage from '../images/revenant_caves.png';
import SandImage from '../images/sand.png';
import ScarImage from '../images/scar.png';
import TzhaarImage from '../images/tzhaar.png';
import UndercityImage from '../images/undercity.png';
import VerzikViturImage from '../images/verzik_vitur.png';
import WardensImage from '../images/wardens.png';
import WildernessImage from '../images/wilderness.png';
import ZanarisImage from '../images/zanaris.png';
import ZulAndraImage from '../images/zul_andra.png';
import { useEffect, useState } from 'react';
import { getIcon, getSprite } from '../images/osrs/imageUtils';
import { useBackgroundStore } from '../store/background';
import { useFilterConfigStore } from '../store/filterConfigurationStore';
import { useFilterStore } from '../store/filterStore';
import { colors } from '../styles/MuiTheme';
import { BackgroundImage, imageFromBackgroundImage } from '../types/Images';
import { fontFamilyFromFontType } from '../types/Rs2fEnum';
import { colorHexToRgbaCss } from '../utils/Color';
export var ItemMenuPreview = function (_a) {
    var _b, _c;
    var itemName = _a.itemName, input = _a.input;
    var activeFilterId = useFilterStore(function (state) {
        return Object.keys(state.filters).find(function (id) { return state.filters[id].active; });
    });
    var activeConfig = useFilterConfigStore(function (state) {
        var _a, _b, _c;
        return (_c = (_b = (_a = state.filterConfigurations) === null || _a === void 0 ? void 0 : _a[activeFilterId]) === null || _b === void 0 ? void 0 : _b.inputConfigs) === null || _c === void 0 ? void 0 : _c[input.macroName];
    });
    var menuTextColor = colorHexToRgbaCss((_b = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.menuTextColor) !== null && _b !== void 0 ? _b : (_c = input.default) === null || _c === void 0 ? void 0 : _c.menuTextColor);
    return (_jsx(Box, { children: _jsx("div", __assign({ style: {
                display: 'flex',
                backgroundColor: colors.rsLightBrown,
                border: "1px solid ".concat(colors.rsLightBrown),
            } }, { children: _jsxs("div", __assign({ style: {
                    borderRadius: '2px',
                } }, { children: [_jsx("div", __assign({ style: {
                            color: colors.rsLightBrown,
                            fontFamily: 'RuneScape',
                            fontSize: '24px',
                            border: "1px solid ".concat(colors.rsLightBrown),
                            borderRadius: '2px',
                            backgroundColor: colors.rsBlack,
                        } }, { children: "Choose Option" })), _jsx("div", __assign({ style: {
                            border: "2px solid ".concat(colors.rsBlack),
                            backgroundColor: colors.rsLightBrown,
                        } }, { children: _jsxs("div", __assign({ style: { margin: '2px' } }, { children: [_jsxs("span", __assign({ style: {
                                        color: colors.rsWhite,
                                        fontFamily: 'RuneScapeSmall',
                                        fontSize: '24px',
                                    } }, { children: ["Take", ' '] })), _jsx("span", __assign({ style: {
                                        color: menuTextColor,
                                        fontFamily: 'RuneScapeSmall',
                                        fontSize: '24px',
                                    } }, { children: input.exampleItem || itemName || 'Item Name' }))] })) }))] })) })) }));
};
var backgroundImages = [
    AbyssalNexusImage,
    AkkhaImage,
    BabaImage,
    BareGroundImage,
    CatacombsOfKourendImage,
    ChambersOfXericImage,
    GodWarsDungeonImage,
    GrassImage,
    KephriImage,
    NightmareImage,
    PrifddinasImage,
    RevenantCavesImage,
    SandImage,
    ScarImage,
    TzhaarImage,
    UndercityImage,
    VerzikViturImage,
    WardensImage,
    WildernessImage,
    ZanarisImage,
    ZulAndraImage,
];
export var ItemLabelPreview = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var itemName = _a.itemName, input = _a.input, sx = _a.sx;
    var activeFilterId = useFilterStore(function (state) {
        return Object.keys(state.filters).find(function (id) { return state.filters[id].active; });
    });
    var activeConfig = useFilterConfigStore(function (state) {
        var _a, _b, _c;
        return (_c = (_b = (_a = state.filterConfigurations) === null || _a === void 0 ? void 0 : _a[activeFilterId]) === null || _b === void 0 ? void 0 : _b.inputConfigs) === null || _c === void 0 ? void 0 : _c[input.macroName];
    });
    var backgroundColor = colorHexToRgbaCss((_b = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.backgroundColor) !== null && _b !== void 0 ? _b : (_c = input.default) === null || _c === void 0 ? void 0 : _c.backgroundColor);
    var borderColor = colorHexToRgbaCss((_d = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.borderColor) !== null && _d !== void 0 ? _d : (_e = input.default) === null || _e === void 0 ? void 0 : _e.borderColor);
    var foregroundColor = colorHexToRgbaCss((_f = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.textColor) !== null && _f !== void 0 ? _f : (_g = input.default) === null || _g === void 0 ? void 0 : _g.textColor);
    var fontType = ((_h = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.fontType) !== null && _h !== void 0 ? _h : (_j = input.default) === null || _j === void 0 ? void 0 : _j.fontType);
    var fontFamily = fontFamilyFromFontType(fontType);
    var textAccent = (_k = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.textAccent) !== null && _k !== void 0 ? _k : (_l = input.default) === null || _l === void 0 ? void 0 : _l.textAccent;
    var textAccentColor = (_m = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.textAccentColor) !== null && _m !== void 0 ? _m : (_o = input.default) === null || _o === void 0 ? void 0 : _o.textAccentColor;
    var textAccentStyle = {};
    var _v = useState(undefined), icon = _v[0], setIcon = _v[1];
    var iconConfig = (_p = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.icon) !== null && _p !== void 0 ? _p : (_q = input.default) === null || _q === void 0 ? void 0 : _q.icon;
    useEffect(function () {
        var _a, _b;
        switch (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.type) {
            case 'itemId':
                getIcon(iconConfig.itemId, setIcon);
                break;
            case 'sprite':
                getSprite((_a = iconConfig.spriteId) !== null && _a !== void 0 ? _a : 0, (_b = iconConfig.spriteIndex) !== null && _b !== void 0 ? _b : 0, setIcon);
                break;
            case 'current':
                if (input.exampleItemId) {
                    getIcon(input.exampleItemId, setIcon);
                }
                break;
            default:
                break;
        }
    }, [setIcon, iconConfig, input.exampleItemId]);
    switch (textAccent) {
        // Outline
        case 2:
            textAccentStyle = {
                WebkitTextStroke: "1px ".concat((_r = colorHexToRgbaCss(textAccentColor)) !== null && _r !== void 0 ? _r : 'rgb(0,0,0,0)'),
            };
            break;
        // None
        case 3:
            textAccentStyle = {};
            break;
        // Shadow Bold
        case 4:
            textAccentStyle = {
                textShadow: '2px 2px #000000',
            };
            break;
        // Shadow is default
        case 1:
        default:
            textAccentStyle = {
                textShadow: '1px 1px #000000',
            };
            break;
    }
    var _w = useState(Math.floor(Math.random() * backgroundImages.length)), randomBackgroundImageIndex = _w[0], setBackgroundImageIndex = _w[1];
    var activeBackground = useBackgroundStore(function (state) { return state.background; });
    useEffect(function () {
        if (activeBackground === BackgroundImage.Random) {
            var interval_1 = window.setInterval(function () {
                setBackgroundImageIndex(Math.floor(Math.random() * backgroundImages.length));
            }, Math.floor(Math.random() * (20000 - 10000 + 1)) + 10000);
            return function () {
                clearInterval(interval_1);
            };
        }
    }, [activeBackground]);
    var activeBackgroundImage = null;
    if (activeBackground === BackgroundImage.Default) {
        activeBackgroundImage = imageFromBackgroundImage((_s = input.backgroundImage) !== null && _s !== void 0 ? _s : BackgroundImage.GodWarsDungeon);
    }
    else if (activeBackground === BackgroundImage.Random) {
        activeBackgroundImage = backgroundImages[randomBackgroundImageIndex];
    }
    else {
        activeBackgroundImage = imageFromBackgroundImage(activeBackground);
    }
    var isHidden = (_t = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.hidden) !== null && _t !== void 0 ? _t : (_u = input.default) === null || _u === void 0 ? void 0 : _u.hidden;
    return (_jsxs("div", __assign({ style: {
            border: '3px solid #2c2721',
            backgroundRepeat: 'repeat',
            backgroundPosition: 'center',
            backgroundImage: "url(".concat(activeBackgroundImage, ")"),
            display: 'flex',
            alignItems: 'center',
        } }, { children: [icon && (_jsx("img", { style: {
                    verticalAlign: 'middle',
                    marginLeft: '4px',
                }, src: icon.src, alt: icon.name })), _jsx("div", __assign({ style: __assign({ margin: '6px', display: 'flex', alignItems: 'center', backgroundColor: isHidden ? undefined : backgroundColor, 
                    // background:
                    //     'linear-gradient(45deg,rgb(255, 255, 255) 0%, rgb(0, 0, 0) 100%)',
                    border: isHidden ? undefined : "1px solid ".concat(borderColor) }, textAccentStyle) }, { children: _jsx("span", { children: _jsx("span", __assign({ style: {
                            padding: '2px',
                            color: isHidden
                                ? '#808080'
                                : (foregroundColor !== null && foregroundColor !== void 0 ? foregroundColor : '#ffffff'),
                            fontSize: '24px',
                            fontFamily: fontFamily,
                            verticalAlign: 'middle',
                            lineHeight: '1.0',
                        } }, { children: input.exampleItem || itemName || 'Item Name' })) }) }))] })));
};
